import React, { useState } from "react";
import PropTypes from "prop-types";
import * as moment from "moment";
import CsvDownloader from "react-csv-downloader";
import { useTranslation } from "react-i18next";

import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import IXlsx from "examples/Icons/IXlsx";

const CSVDownloadBtn = ({ datas, downloadLoading, onExcelExport, isModalOpen }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExcelDownload = () => {
    if (onExcelExport) {
      onExcelExport();
    }
    handleClose();
  };

  return (
    <>
      <SoftButton
        disabled={downloadLoading}
        variant="gradient"
        color="success"
        display="flex"
        alignItems="center"
        onClick={handleClick}
        aria-controls={open ? "download-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <SoftTypography component="label" variant="caption" fontWeight="bold" color="white" mr={1}>
          {t("download.by")}
        </SoftTypography>
        <IXlsx size={"25px"} />
      </SoftButton>

      <Menu
        id="download-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "download-button",
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* CSV Download Option */}
        <MenuItem>
          <CsvDownloader
            filename={`Fora_to_EasyPay_Transactions_${moment(new Date()).format(
              "YYYY_MM_DD_HHmmss"
            )}`}
            extension=".csv"
            separator=";"
            wrapColumnChar="'"
            datas={datas}
            disabled={downloadLoading}
            style={{ textDecoration: "none", color: "inherit", width: "100%" }}
          >
            <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
              <ListItemIcon>
                <IXlsx size={"20px"} />
              </ListItemIcon>
              <ListItemText primary={t("download.csv")} onClick={handleClose} />
            </div>
          </CsvDownloader>
        </MenuItem>

        {/* Excel Download Option */}
        <MenuItem onClick={handleExcelDownload}>
          <ListItemIcon>
            <IXlsx size={"20px"} />
          </ListItemIcon>
          <ListItemText primary={t("download.excel")} />
        </MenuItem>
      </Menu>
    </>
  );
};

CSVDownloadBtn.propTypes = {
  datas: PropTypes.any,
  downloadLoading: PropTypes.bool,
  onExcelExport: PropTypes.func, // New prop for Excel export handler
  isModalOpen: PropTypes.bool, // New prop to detect modal state
};

export default CSVDownloadBtn;
